
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/orders",
      function () {
        return require("private-next-pages/[domain]/orders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/orders"])
      });
    }
  